module.exports = __webpack_public_path__ + "static/media/pic4-.2c81aab6.jpg";